/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { DebtorsInvoiceDataGrid } from '@/components/tables/DebtorsInvoiceTable';
import RefreshPolicyButton from '@/components/buttons/RefreshPolicyButton';
import DebtorAutomationPanel from '../DebtorAutomationPanel';

export const DebtorDetailsTab = () => {
	const { getFeatureFlags } = useFeatureFlagContext();
	const automatedDebtors = Boolean(getFeatureFlags('automatedDebtors')?.active);

	return (
		<Stack spacing={4} width='100%' direction='column'>
			<Stack spacing={2}>
				<Stack
					direction='row'
					sx={{ justifyContent: 'space-between', alignItems: 'center', pt: '1em' }}
					spacing={1}
					width='100%'
				>
					<Typography variant='form_label'>Invoices</Typography>
					<RefreshPolicyButton />
				</Stack>

				<DebtorsInvoiceDataGrid showActionsColumn />
			</Stack>

			{automatedDebtors && <DebtorAutomationPanel />}
		</Stack>
	);
};
DebtorDetailsTab.displayName = 'DebtorDetailsTab';
